import { Controller } from 'react-hook-form';
import DatePicker from 'components/DatePicker/DatePicker';
import { DATE_FORMAT } from 'constants/general';

import type { FieldValues } from 'react-hook-form';
import type IDateFieldsWrapper from './interfaces/IDateFieldsWrapper';

import styles from './sass/DateFieldsWrapper.module.scss';

function DateFieldsWrapper<T extends FieldValues>({
  control,
  startFieldName,
  endFieldName,
  startDate,
  onStartDateChange,
  startFieldLabel,
  endFieldLabel,
  startPlaceholder,
  endPlaceholder,
  startRequired = false,
  endRequired = false,
  className,
}: IDateFieldsWrapper<T>) {
  return (
    <div className={className || styles.wrapper}>
      <Controller
        control={control}
        name={startFieldName}
        render={({
          field: {
            name,
            value,
            onChange,
          },
          fieldState: { error },
        }) => (
          <DatePicker
            label={startFieldLabel}
            error={error?.message}
            onChange={(date) => {
              if (onStartDateChange) {
                onStartDateChange(date);
              }
              onChange(date);
            }}
            name={name}
            value={value}
            placeholder={startPlaceholder || DATE_FORMAT}
            required={startRequired}
            maxDate={new Date()}
          />
        )}
      />
      <Controller
        control={control}
        name={endFieldName}
        render={({
          field: {
            name,
            value,
            onChange,
          },
          fieldState: { error },
        }) => (
          <DatePicker
            label={endFieldLabel}
            error={error?.message}
            onChange={onChange}
            name={name}
            value={value}
            minDate={startDate}
            placeholder={endPlaceholder || DATE_FORMAT}
            required={endRequired}
          />
        )}
      />
    </div>
  );
}

export default DateFieldsWrapper;
